import React, { useEffect, useState } from "react";
import { Row, Card, Col, ProgressBar } from "react-bootstrap";
import { AiFillProduct } from "react-icons/ai";
import { FaIndianRupeeSign } from "react-icons/fa6";
import { GrVmMaintenance } from "react-icons/gr";
import AssetTrendChart from "./AssetTrendChart";
import { IoIosWarning } from "react-icons/io";
import {
  FiRepeat,
  FiMapPin,
  FiTrash2,
  FiUserCheck,
  FiTool,
  FiClock,
  FiAlertTriangle,
  FiCheckCircle,
  FiXCircle,
} from "react-icons/fi";
import CategoryChart from "./CategoryChart";
import { FiUser } from "react-icons/fi";
import DisposedChart from "./DisposedChart";
import { FcDepartment } from "react-icons/fc";
import MaintenanceCostChart from "./MaintenanceCost";
import { FaShieldAlt } from "react-icons/fa";
import RecentLog from "./RecentLog";
import {
  getAssetAlertsApi,
  getAssetTotalCostApi,
  getDashboardDataApi,
  getMaintenanceCostApi,
  getWarrantyExpiryCountApi,
} from "../../../services/DashboardServices";
import { toast } from "react-toastify";
import { formatToNumber } from "../../../utilities";
import { Link } from "react-router-dom";

const priorityMeta = {
  1: {
    color: "danger",
    icon: <FiAlertTriangle />,
  },
  2: {
    color: "danger",
    icon: <FiXCircle />,
  },
  3: {
    color: "warning",
    icon: <FiAlertTriangle />,
  },
  4: {
    color: "warning",
    icon: <FiClock />,
  },
  5: {
    color: "primary",
    icon: <FiRepeat />,
  },
  6: {
    color: "info",
    icon: <FiMapPin />,
  },
  7: {
    color: "warning",
    icon: <FiTrash2 />,
  },
  8: {
    color: "secondary",
    icon: <FiUserCheck />,
  },
  9: {
    color: "danger",
    icon: <FiTool />,
  },
  10: {
    color: "success",
    icon: <FiCheckCircle />,
  },
};

const AdminDas = () => {
  const [alertData, setAlertData] = useState([]);
  const [alertLoading, setAlertLoading] = useState(false);
  const [assetLogData, setAssetLogData] = useState([]);
  const [topDepartmentData, setTopdepartmentData] = useState([]);
  const [userRoleData, setUserRoleData] = useState([]);
  const [assetCountData, setAssetCountData] = useState(null);
  const [warentExpiryCount, setWarentyExpiryCount] = useState(0);
  const [assetTotalCost, setAssetTotalCost] = useState(0);
  const [maintenanceType, setMaintenanceType] = useState("year");
  const [maintenanceCost, setMaintenanceCost] = useState(0);
  const getWarentyCount = () => {
    getWarrantyExpiryCountApi()
      .then((res) => {
        setWarentyExpiryCount(res?.data?.count || 0);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      });
  };
  const getAlert = () => {
    setAlertLoading(true);
    getAssetAlertsApi()
      .then((res) => {
        const data = res?.data?.alerts || [];
        const mergeData = data.map((alert) => ({
          ...alert,
          ...priorityMeta[alert.priority],
        }));
        setAlertData(mergeData || []);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setAlertLoading(false);
      });
  };

  const getDashboardData = () => {
    getDashboardDataApi()
      .then((res) => {
        const data = res?.data?.data || {};
        setAssetLogData(data?.recent_logs || []);
        setTopdepartmentData(data?.top_departments || []);
        setUserRoleData(data?.users_by_role || []);
        setAssetCountData(data?.summary || null);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      });
  };

  const getAssetCost = () => {
    getAssetTotalCostApi()
      .then((res) => {
        setAssetTotalCost(res?.data?.total_current_cost || 0);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      });
  };

  const getMaintenanceCost = () => {
    getMaintenanceCostApi({ type: maintenanceType })
      .then((res) => {
        setMaintenanceCost(res?.data?.total_maintenance_cost || 0);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      });
  };
  useEffect(() => {
    getAlert();
    getDashboardData();
    getWarentyCount();
    getAssetCost();
  }, []);

  useEffect(() => {
    getMaintenanceCost();
  }, [maintenanceType]);
  const maxRoleCount = Math.max(...userRoleData.map((r) => r.count));
  const maxDepartmentCount = Math.max(
    ...topDepartmentData.map((r) => r.asset_count)
  );
  return (
    <div className="container-fluid p-0">
      <div className="row g-4 mb-4">
        {/* <Col xs={12} sm={6} lg={3}>
          <Card className="border-0 shadow-sm h-100">
            <Card.Body className="d-flex align-items-center justify-content-between">
              <div>
                <h6 className="mb-1">Total Items</h6>
                <h3 className="fw-bold text-darker">0</h3>
              </div>
              <div
                className="rounded-3 p-3 bg-primary bg-opacity-10 d-flex align-items-center justify-content-center"
                style={{ width: 48, height: 48 }}
              >
                <span className="text-primary fs-3">
                  <AiFillProduct />
                </span>
              </div>
            </Card.Body>
          </Card>
        </Col> */}

        <Col lg={6}>
          <Card className="border-0 shadow-sm h-100">
            <Card.Body className="d-flex align-items-center justify-content-between">
              <div>
                <h6 className="mb-2">
                  Total Assets ({formatToNumber(assetCountData?.total_assets)})
                </h6>
                <div className="d-flex gap-2 flex-wrap">
                  {/* <span
                    className="d-flex align-items-center justify-content-center rounded-circle"
                    style={{
                      minWidth: "26px",
                      minHeight: "26px",
                      background: "rgba(13, 110, 253, 0.1)",
                      color: "#0d6efd",
                      fontSize: "0.75rem",
                      padding:'2px'
                    }}
                  >
                    5
                  </span>

                  <span
                    className="d-flex align-items-center justify-content-center rounded-circle"
                    style={{
                      width: "26px",
                      height: "26px",
                      background: "rgba(13, 202, 240, 0.1)", // soft info
                      color: "#0dcaf0",
                      fontSize: "0.75rem",
                    }}
                  >
                    5
                  </span>

                  <span
                    className="d-flex align-items-center justify-content-center rounded-circle"
                    style={{
                      width: "26px",
                      height: "26px",
                      background: "rgba(220, 53, 69, 0.1)", // soft danger
                      color: "#dc3545",
                      fontSize: "0.75rem",
                    }}
                  >
                    5
                  </span>

                  <span
                    className="d-flex align-items-center justify-content-center rounded-circle"
                    style={{
                      width: "26px",
                      height: "26px",
                      background: "rgba(255, 193, 7, 0.1)", // soft warning
                      color: "#ffc107",
                      fontSize: "0.75rem",
                    }}
                  >
                    5
                  </span> */}
                  <Link
                    to="/assets/table-view?status=IN_STOCK"
                    className="badge rounded-1 text-bg-info-soft"
                    style={{ padding: "0.5rem 0.45rem" }}
                  >
                    <span
                      className="me-1"
                      style={{
                        fontSize: "0.5rem",
                        padding: "3px",
                        color: "white",
                        minWidth: "6px",
                        minHeight: "6px",
                        borderRadius: "20%",
                        backgroundColor: "#0d6efd",
                      }}
                    >
                      {formatToNumber(assetCountData?.in_stock)}
                    </span>
                    In Stock
                  </Link>
                  <Link
                    to="/assets/table-view?status=ALLOCATED"
                    className="badge rounded-1 text-bg-success-soft"
                    style={{ padding: "0.5rem 0.45rem" }}
                  >
                    <span
                      className="me-1"
                      style={{
                        fontSize: "0.5rem",
                        padding: "3px",
                        color: "white",
                        minWidth: "6px",
                        minHeight: "6px",
                        borderRadius: "20%",
                        backgroundColor: "#11b50fff",
                      }}
                    >
                      {formatToNumber(assetCountData?.allocated)}
                    </span>
                    Allocated
                  </Link>
                  <Link
                    to="/assets/table-view?status=DISPOSED"
                    className="badge rounded-1 text-bg-danger-soft"
                    style={{ padding: "0.5rem 0.45rem" }}
                  >
                    <span
                      className="me-1"
                      style={{
                        fontSize: "0.5rem",
                        padding: "3px",
                        color: "white",
                        minWidth: "6px",
                        minHeight: "6px",
                        borderRadius: "20%",
                        backgroundColor: "#dc3545",
                      }}
                    >
                      {formatToNumber(assetCountData?.disposed)}
                    </span>
                    Disposed
                  </Link>
                  <Link
                    to="/assets/table-view?status=IN_REPAIR"
                    className="badge rounded-1 text-bg-warning-soft"
                    style={{ padding: "0.5rem 0.45rem" }}
                  >
                    <span
                      className="me-1"
                      style={{
                        fontSize: "0.5rem",
                        padding: "3px",
                        color: "white",
                        minWidth: "6px",
                        minHeight: "6px",
                        borderRadius: "20%",
                        backgroundColor: "#ffc107",
                      }}
                    >
                      {formatToNumber(assetCountData?.in_repair)}
                    </span>
                    Maintenance
                  </Link>
                </div>
              </div>
              {/* <div className="d-flex flex-column text-end">
                <div className="d-flex align-items-center gap-1">
                  <span
                    style={{
                      width: "6px",
                      height: "6px",
                      borderRadius: "50%",
                      backgroundColor: "#0d6efd",
                    }}
                  ></span>
                  <span style={{ fontSize: "0.65rem" }} className="text-dark">
                    In Stock
                  </span>
                </div>

                <div className="d-flex align-items-center gap-1">
                  <span
                    style={{
                      width: "6px",
                      height: "6px",
                      borderRadius: "50%",
                      backgroundColor: "#0dcaf0",
                    }}
                  ></span>
                  <span style={{ fontSize: "0.65rem" }} className="text-dark">
                    Allocated
                  </span>
                </div>

                <div className="d-flex align-items-center gap-1">
                  <span
                    style={{
                      width: "6px",
                      height: "6px",
                      borderRadius: "50%",
                      backgroundColor: "#dc3545",
                    }}
                  ></span>
                  <span style={{ fontSize: "0.65rem" }} className="text-dark">
                    Disposed
                  </span>
                </div>

                <div className="d-flex align-items-center gap-1">
                  <span
                    style={{
                      width: "6px",
                      height: "6px",
                      borderRadius: "50%",
                      backgroundColor: "#ffc107",
                    }}
                  ></span>
                  <span style={{ fontSize: "0.65rem" }} className="text-dark">
                    Maintenance
                  </span>
                </div>
              </div> */}
              <div
                className="rounded-3 p-3 bg-primary bg-opacity-10 d-flex align-items-center justify-content-center"
                style={{ width: 48, height: 48 }}
              >
                <span className="text-primary fs-3">
                  <AiFillProduct />
                </span>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col xs={12} sm={6} lg={3}>
          <Card
            className="border-0 shadow-sm h-100"
            style={{ cursor: "pointer" }}
          >
            <Card.Body className="d-flex align-items-center justify-content-between">
              <div>
                <h6 className="mb-1">Asset value</h6>
                <h3 className="fw-bold text-darker">
                  ₹{formatToNumber(assetTotalCost)}
                </h3>
              </div>
              <div
                className="rounded-3 p-3 bg-info bg-opacity-10 d-flex align-items-center justify-content-center"
                style={{ width: 48, height: 48 }}
              >
                <span className="text-info fs-3">
                  <FaIndianRupeeSign />
                </span>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col xs={12} sm={6} lg={3}>
          <Card className="border-0 shadow-sm h-100">
            <Card.Body>
              <div className="d-flex flex-column h-100 gap-2">
                {/* Row 1: Title and Cost */}
                <div className="d-flex justify-content-between align-items-center mb-0">
                  <h6 className="mb-0">Maintenance Cost</h6>
                </div>

                {/* Row 2: Filter buttons and Icon */}
                <div className="d-flex justify-content-between gap-2">
                  <h3 className="fw-bold text-darker mb-0">
                    ₹{formatToNumber(maintenanceCost)}
                  </h3>
                  <div className="d-flex gap-1 flex-wrap">
                    <button
                      onClick={() => setMaintenanceType("year")}
                      className={`btn btn-outline-light ${
                        maintenanceType === "year" ? "active" : ""
                      }`}
                      style={{ padding: "0rem 0.5rem" }}
                    >
                      <span
                        className="text-dark fw-medium"
                        style={{ fontSize: "0.7rem" }}
                      >
                        Y
                      </span>
                    </button>
                    <button
                      onClick={() => setMaintenanceType("month")}
                      className={`btn btn-outline-light ${
                        maintenanceType === "month" ? "active" : ""
                      }`}
                      style={{ padding: "0rem 0.5rem" }}
                    >
                      <span
                        className="text-dark fw-medium"
                        style={{ fontSize: "0.7rem" }}
                      >
                        M
                      </span>
                    </button>
                    <button
                      onClick={() => setMaintenanceType("all")}
                      className={`btn btn-outline-light ${
                        maintenanceType === "all" ? "active" : ""
                      }`}
                      style={{ padding: "0rem 0.5rem" }}
                    >
                      <span
                        className="text-dark fw-medium"
                        style={{ fontSize: "0.7rem" }}
                      >
                        All
                      </span>
                    </button>
                  </div>

                  {/* <div
                    className="rounded-3 p-3 bg-warning bg-opacity-10 d-flex align-items-center justify-content-center"
                    style={{ width: 48, height: 48 }}
                  >
                    <span className="text-warning fs-3">
                      <GrVmMaintenance />
                    </span>
                  </div> */}
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </div>

      <div className="row g-3 mb-3">
        <div className="col-lg-6">
          <AssetTrendChart />
        </div>
        <div className="col-lg-3">
          <CategoryChart />
        </div>
        <div className="col-lg-3">
          <div className="card border-0 shadow-sm">
            <div className="p-2 d-flex justify-content-between align-items-center">
              <div className="d-flex">
                <IoIosWarning className="text-danger me-1" />
                <h5 className="text-danger">Alerts</h5>
              </div>
              <div className="align-self-start">
                <span
                  className="fw-medium text-dark"
                  style={{ fontSize: "0.7rem" }}
                >
                  Total
                </span>
                <span
                  className="text-darker fw-medium"
                  style={{ fontSize: "0.6rem" }}
                >{`(${alertData.length || 0})`}</span>
              </div>
            </div>
            <div className="card-body py-2">
              <div
                className="row gy-1 overflow-auto scroll-container"
                style={{ maxHeight: "250px" }}
              >
                {alertData
                  .slice()
                  .sort((a, b) => a.priority - b.priority)
                  .map((alerts, idx) => (
                    <Col xs={12} key={idx}>
                      <Link
                        to={`/assets/table-view?${alerts.filter_param}`}
                        style={{ textDecoration: "none" }}
                      >
                        <div
                          className={`d-flex justify-content-between align-items-center p-2 rounded bg-${alerts.color}-subtle`}
                        >
                          <div className="d-flex align-items-start gap-2">
                            <span
                              className={`align-self-start text-${alerts.color}`}
                              style={{ fontSize: "0.85rem" }}
                            >
                              {alerts.icon}
                            </span>
                            <span
                              style={{ fontSize: "0.75rem" }}
                              className={`text-${alerts.color} fw-medium`}
                            >
                              {alerts.title}
                            </span>
                          </div>
                          <span
                            className={`rounded-2 align-self-start badge text-bg-${alerts.color}`}
                            style={{ padding: "0.3rem 0.5rem" }}
                          >
                            {formatToNumber(alerts.count)}
                          </span>
                        </div>
                      </Link>
                    </Col>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row g-3 mb-3">
        <div className="col-lg-4">
          <MaintenanceCostChart />
        </div>

        <div className="col-lg-4">
          <RecentLog data={assetLogData || []} />
        </div>

        <div className="col-lg-4">
          <DisposedChart />
        </div>
      </div>
      <div className="row g-3 mb-3">
        <div className="col-lg-4">
          <Card className="border-0 shadow-sm">
            <Card.Body>
              <div className="d-flex align-items-center mb-3">
                <FcDepartment className="me-2 text-success" />
                <h6 className="m-0 fw-bold">Top Departments</h6>
              </div>

              {topDepartmentData.map((department, idx) => {
                const percentage =
                  (department.asset_count / maxDepartmentCount) * 100;
                return (
                  <div
                    key={idx}
                    className="d-flex align-items-center mb-2"
                    style={{ fontSize: "0.9rem" }}
                  >
                    {/* Icon + Role Name */}
                    <div
                      className="d-flex align-items-center"
                      style={{ width: "90px" }}
                    >
                      <span
                        className="fw-medium text-dark"
                        style={{ fontSize: "0.7rem" }}
                      >
                        {department.name}
                      </span>
                    </div>

                    {/* Progress bar */}
                    <div className="flex-grow-1 mx-2">
                      <div
                        className="progress"
                        style={{ height: "6px", backgroundColor: "#f1f3f5" }}
                      >
                        <div
                          className="progress-bar"
                          style={{
                            width: `${percentage}%`,
                            backgroundColor: "rgba(12, 27, 49, 0.64)",
                          }}
                        />
                      </div>
                    </div>

                    {/* Count */}
                    <div style={{ width: "20px", textAlign: "right" }}>
                      {department.asset_count}
                    </div>
                  </div>
                );
              })}
            </Card.Body>
          </Card>
        </div>
        <div className="col-lg-4">
          <Card className="border-0 shadow-sm">
            <Card.Body>
              <div className="d-flex align-items-center mb-3">
                <FiUser className="me-2 text-success" />
                <h6 className="m-0 fw-bold">Users by Role</h6>
              </div>

              {userRoleData.map((role, idx) => {
                const percentage = (role.count / maxRoleCount) * 100;
                return (
                  <div
                    key={idx}
                    className="d-flex align-items-center mb-2"
                    style={{ fontSize: "0.9rem" }}
                  >
                    <div
                      className="d-flex align-items-center"
                      style={{ width: "80px" }}
                    >
                      <FiUser className="me-1 text-dark" size="12" />
                      <span
                        className="text-dark fw-medium"
                        style={{ fontSize: "0.65rem" }}
                      >
                        {" "}
                        {role.role}
                      </span>
                    </div>
                    <div className="flex-grow-1 mx-2">
                      <div
                        className="progress"
                        style={{ height: "6px", backgroundColor: "#f1f3f5" }}
                      >
                        <div
                          className="progress-bar"
                          style={{
                            width: `${percentage}%`,
                            backgroundColor: "#20c997",
                          }}
                        />
                      </div>
                    </div>

                    <div style={{ width: "20px", textAlign: "right" }}>
                      {role.count}
                    </div>
                  </div>
                );
              })}
            </Card.Body>
          </Card>
        </div>
        <div className="col-lg-4">
          <div className="card">
            <div className="card-body">
              <div className="d-flex gap-1">
                <FaShieldAlt size="20" />
                <h5>Waranty Expiry Soon</h5>
              </div>
              <div className="text-center my-5">
                <div className="text-danger fs-3 fw-bold">
                  {warentExpiryCount}
                </div>
                <span className="text-dark small">
                  Assets with warranty expiring in 30 days
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDas;
